import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MicOffIcon from '@mui/icons-material/MicOff';
import { silenceWarningStyles } from './styles';

interface SilenceWarningPopupProps {
  onDismiss: () => void;
}

export const SilenceWarningPopup: React.FC<SilenceWarningPopupProps> = ({
  onDismiss,
}) => {
  return (
    <>
      <Box sx={silenceWarningStyles.backdrop} onClick={onDismiss} />

      <Box sx={silenceWarningStyles.popup}>
        <IconButton
          onClick={onDismiss}
          sx={silenceWarningStyles.closeButton}
          aria-label="Close warning"
        >
          <CloseIcon />
        </IconButton>

        <Box sx={silenceWarningStyles.iconContainer}>
          <MicOffIcon sx={silenceWarningStyles.icon} />
        </Box>

        <Typography variant="h5" sx={silenceWarningStyles.title}>
          No Audio Detected
        </Typography>

        <Typography variant="body1" sx={silenceWarningStyles.message}>
          We're not receiving any audio from your microphone while recording is
          active.
        </Typography>

        <Typography variant="body2" sx={silenceWarningStyles.subtitle}>
          Please check:
        </Typography>

        <Box component="ul" sx={silenceWarningStyles.checkList}>
          <li>You're speaking close enough to the microphone</li>
          <li>The correct microphone is selected</li>
          <li>Your microphone is not muted</li>
        </Box>
      </Box>
    </>
  );
};
